import styles from "./SelectInput.module.scss";

const SelectInput = ({
	label = "",
	name = "",
	value = "",
	onChange = () => {},
	options = [],
	placeholder = "Seleccione una opción",
	required = false,
	disabled = false,
}) => {
	return (
		<div className={styles.selectField}>
			{label ? <label className={styles.label}>{label}</label> : null}
		<select
			name={name}
			value={value}
			onChange={onChange}
			required={required}
			disabled={disabled}
			className={`${styles.select} ${
				value ? styles.selectFilled : styles.selectEmpty
			}`}
		>
			<option value="" disabled={required ? true : false}>
				{placeholder}
			</option>
			{options.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
					</option>
				))}
			</select>
		</div>
	);
};

export default SelectInput;
